<template>
  <section class="navber">
    <nav class="navbar navbar-expand-lg navbar-light bg-light_nav fixed-top">
      <router-link to="/"
        ><span class="navbar-brand logo_test" @click="close_drop()">
          <img class="logo" src="../assets/img/volunteer2.png" /> volunteer
        </span></router-link
      >
      <div class="phone_nav">
        <router-link
          class=""
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          to="#"
          >Donate</router-link
        >
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        id="navbarTogglerButton"
      >
        <span aria-expanded="false"><i class="fas fa-bars nav_toggle"></i></span>
        <span
          class="collapse navber-toggler-close"
          id="navbarSupportedContent"
          aria-hidden="true"
          >&times;</span
        >
      </button>
      <transition name="fade" appear>
        <div
          class="collapse navbar-collapse"
          text="Dropdown Button"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mr-auto"></ul>
          <form class="form-inline my-lg-0 nav_collapse">
            <ul class="navbar-nav mr-auto header-btns" style="margin-top: -5px">
              <li class="nav-item animation_colum" @click="close_drop()">
                <router-link
                  to="/about-us"
                  active-class="active border_nav"
                  exact
                  class="nav-link nav_link_one"
                  >About Us
                </router-link>
              </li>
              <li class="nav-item" @click="close_drop()">
                <router-link
                  to="/become-volunteer"
                  active-class="active border_nav"
                  exact
                  class="nav-link"
                  >Become Volunteer
                </router-link>
              </li>
              <li class="nav-item" @click="close_drop()">
                <router-link
                  to="/events"
                  active-class="active border_nav"
                  exact
                  class="nav-link nav_link_three"
                  >Events</router-link
                >
              </li>
              <li class="nav-item" @click="close_drop()">
                <router-link
                  to="/gallary"
                  active-class="active border_nav"
                  exact
                  class="nav-link nav_link_four"
                  >Gallery
                </router-link>
              </li>
              <li class="nav-item" @click="close_drop()">
                <router-link
                  to="/info_center"
                  active-class="active border_nav"
                  exact
                  class="nav-link nav_link_five"
                  >Info center</router-link
                >
              </li>
              <li @click="HasLogin()" class="nav_left_head desktop_nav">
                <a class="btn-2 login_button">Login</a>
              </li>
              <li class="nav_left_head desktop_nav" @click="close_drop()">
                <router-link class="btn-2" aria-label="Toggle navigation" to="/donate"
                  >Donate</router-link
                >
              </li>
              <li>
                <a @click="search" class="search_icon nav_search_icon_p">
                  <i class="fa"> <SearchIcon /></i>
                </a>
              </li>
              <li>
                <a @click="darkThemeSwitch" class="search_icon color_change_icon">
                  <span id="sun"> <SunIcon /> </span>
                  <span id="moon"><LightIcon /> </span>
                </a>
              </li>
              <!-- search finish-share-massage  -->
              <transition name="fade" appear>
                <div class="modal-overlay" v-if="open"></div>
              </transition>
              <transition name="slide" appear>
                <div class="modal modal__search" v-if="open">
                  <span class="button" @click="open = false">
                    <!-- <i class="fas fa-times share-close"></i> -->
                    <span class="navber-toggler-close search_close__p">&times;</span>
                  </span>
                  <!-- Search form -->
                  <form
                    class="form-inline d-flex justify-content-center search_form_in"
                    id="search_form"
                  >
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <i class="collap"><SearchIcon /> </i>
                  </form>
                </div>
              </transition>
              <LoginForm />
            </ul>
          </form>
        </div>
      </transition>
    </nav>
  </section>
</template>
<script>
import LoginForm from "./login.vue";
import SunIcon from "../assets/svg/sun";
import LightIcon from "../assets/svg/light";
import SearchIcon from "../assets/svg/search";
export default {
  name: "navber",
  components: {
    LoginForm,
    SunIcon,
    LightIcon,
    SearchIcon,
  },
  data() {
    return {
      open: false,
      innerOpen: false,
      align: "left",
      closeNav: true,
    };
  },

  mounted() {
    this.$root.navClickHook = this;
    this.themeMode();
  },
  watch: {
    align: function () {
      this.open = false;
    },
  },
  methods: {
    close_drop() {
      if (
        document.getElementById("navbarTogglerButton").className == "navbar-toggler" &&
        window.innerWidth < 991
      ) {
        var navToggler = document.getElementById("navbarTogglerButton");
        navToggler.click();
      }
    },
    globalClick(event) {
      if (event.clientY > 80 && window.innerWidth > 989) {
        this.menuClick(-1);
      } else {
        // console.log(event.clientY);
        if (event.clientY > 500) {
          this.menuClick(-1);
          if (
            document.getElementById("navbarTogglerButton").className == "navbar-toggler"
          ) {
            // Expanded
            document.getElementById("navbarTogglerButton").click();
          }
        }
      }
    },
    collapseClose() {
      //console.log("Collaps Tried!");
      if (window.innerWidth < 991) {
        // console.log("Collaps Clicked!")
        var navToggler = document.getElementById("navbarTogglerButton");
        navToggler.click();
      } else {
        // this.menuClick(-1);
      }
    },
    menuClick() {
      //console.log("Menu Click: " + type);
    },

    search() {
      this.open = !this.open;
    },
    HasLogin() {
      this.$root.loginFormShow = true;
    },
    clickContent() {
      this.innerOpen = true;
    },

    themeMode() {
      var theme = localStorage.getItem("theme");
      document.body.classList.toggle(theme);
      this.updateIcon();
    },

    _removeDarkTheme() {
      let darkThemeLinkEl = document.querySelector("#dark-theme-style");
      let parentNode = darkThemeLinkEl.parentNode;
      parentNode.removeChild(darkThemeLinkEl);
    },
    darkThemeSwitch() {
      let darkThemeLinkEl = document.querySelector("#dark-theme-style");
      if (!darkThemeLinkEl) {
        // this._addDarkTheme();
      } else {
        this._removeDarkTheme();
      }

      document.body.classList.toggle("light");
      document.body.classList.toggle("dark");
      if (document.body.classList.contains("light")) {
        localStorage.setItem("theme", "light");
      } else {
        localStorage.setItem("theme", "dark");
      }
      if (document.body.classList.contains("light")) {
        document.querySelector("#sun").classList.add("icon_light");
        document.querySelector("#moon").classList.remove("icon_dark");
      } else {
        document.querySelector("#moon").classList.add("icon_dark");
        document.querySelector("#sun").classList.remove("icon_light");
      }
      this.$root.changeColor = !this.$root.changeColor;
    },
    updateIcon() {
      if (document.body.classList.contains("light")) {
        document.querySelector("#sun").classList.add("icon_light");
      } else {
        document.querySelector("#moon").classList.add("icon_dark");
      }
    },
  },
};
</script>
